"use client";
import React, { memo, useRef, useState, useEffect } from "react";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/audio.css";
import "@vidstack/react/player/styles/default/layouts/video.css";

import { MediaPlayer, MediaProvider, Poster, Track } from "@vidstack/react";
import {
  DefaultVideoLayout,
  defaultLayoutIcons,
} from "@vidstack/react/player/layouts/default";

const CustomVideoPlayer = ({
  src = "",
  poster = "",
  height = "100%",
  width = "100%",
  aspectRatio = "16/9",
  className = "",
  fluid = true,
}) => {
  log
  return (
    <div
      className={`custom-video-player ${className}`}
      style={{
        width: fluid ? "100%" : width,
        height: fluid ? "auto" : height,
        aspectRatio: fluid ? aspectRatio : undefined,
        position: "relative",
      }}
    >
      <MediaPlayer
        src={src}
        viewType="video"
        streamType="on-demand"
        logLevel="warn"
        crossOrigin
        playsInline
        title="Sprite Fight"
        poster={poster}
      >
        <MediaProvider></MediaProvider>
        <DefaultVideoLayout thumbnails={poster} icons={defaultLayoutIcons} />
      </MediaPlayer>
    </div>
  );
};

export default memo(CustomVideoPlayer);

// import React, { memo } from "react";
// import {
//   Player,
//   ControlBar,
//   BigPlayButton,
//   LoadingSpinner,
//   PlayToggle,
//   VolumeMenuButton,
//   FullscreenToggle,
//   CurrentTimeDisplay,
//   DurationDisplay,
//   TimeDivider,
//   ProgressControl,
//   ReplayControl,
//   ForwardControl,
// } from "video-react";
// import "video-react/dist/video-react.css";

// const CustomVideoPlayer = ({
//   src = "",
//   poster = "",
//   height = "100%",
//   width = "100%",
//   aspectRatio = "auto",
//   className = "",
//   preload = "auto",
//   autoPlay = false,
//   fluid=false,
//   muted = false,
//   loop = false,
//   showBigPlayButton = false,
//   showLoadingSpinner = false,
//   enableControls = [], // directly pass allowed controls
//   videoProps = {},
// }) => {
//   const isEnabled = (name) => enableControls.includes(name);

//   return (
//     <Player
//       playsInline
//       src={src}
//       poster={poster}
//       preload={preload}
//       autoPlay={autoPlay}
//       muted={muted}
//       loop={loop}
//       fluid={fluid}
//       height={height}
//       width={width}
//       aspectRatio={aspectRatio}
//       className={`custom-video ${className}`}
//       {...videoProps}
//     >
//       {showBigPlayButton && <BigPlayButton position="center" />}
//       {showLoadingSpinner && <LoadingSpinner className="loader" />}

//       {/* ✅ Keep controls inside Player context */}
//       <ControlBar autoHide={false} className="custom-player-control" disableDefaultControls>
//         {isEnabled("ReplayControl") && <ReplayControl seconds={5} order={1.1} />}
//         {isEnabled("ForwardControl") && <ForwardControl seconds={5} order={1.2} />}
//         {isEnabled("PlayToggle") && <PlayToggle order={2} />}
//         {isEnabled("CurrentTimeDisplay") && <CurrentTimeDisplay order={3.1} />}
//         {isEnabled("TimeDivider") && <TimeDivider order={3.2} />}
//         {isEnabled("DurationDisplay") && <DurationDisplay order={3.3} />}
//         {isEnabled("VolumeMenuButton") && <VolumeMenuButton order={5} />}
//         {isEnabled("FullscreenToggle") && <FullscreenToggle order={6} />}
//         {isEnabled("ProgressControl") && (
//           <ProgressControl className="custom-progress" />
//         )}
//       </ControlBar>
//     </Player>
//   );
// };

// export default memo(CustomVideoPlayer);
